import { INewCards, ISwimlanes } from '../reducers/types';

export const SWIMLANES_LOCALSTORAGE = 'SWIMLANES_LOCALSTORAGE';
export const NEW_CARD_LOCALSTORAGE = 'NEW_CARD_LOCALSTORAGE';
export const COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE = 'COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE';

export interface ISwimlanesLocalStorage extends ISwimlanes {};
export interface INewCardsLocalStorage extends INewCards {};
